module.exports = __webpack_public_path__ + "img/call-phone-20x20.36a71828.svg";